/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";

const Callout = ({ children }) => (
  <div className="my-7 p-5 border-l-4 border-[#bc6c25] bg-[#bc6c25]/5 rounded-r-2xl text-[#1a2421] text-[15px] leading-relaxed">
    {children}
  </div>
);

const Quote = ({ children, author }) => (
  <blockquote className="my-7 pl-6 border-l-2 border-[#2c4a3b]/30 italic text-[#1a2421] text-lg leading-relaxed font-serif">
    "{children}"
    {author && <footer className="mt-2 not-italic text-xs uppercase tracking-[0.18em] text-[#5c6b61]">— {author}</footer>}
  </blockquote>
);

const TOC = ({ items }) => (
  <nav className="my-7 p-5 bg-[#f0ebe1] rounded-2xl border border-[#2c4a3b]/8 not-prose">
    <p className="text-[10px] uppercase tracking-[0.22em] text-[#bc6c25] font-bold">En este artículo</p>
    <ol className="mt-3 space-y-1.5 text-sm text-[#1a2421]">
      {items.map((it, i) => (
        <li key={i} className="flex gap-2">
          <span className="text-[#bc6c25] font-bold">{i + 1}.</span>
          <a href={`#${it.id}`} className="hover:text-[#bc6c25]">{it.label}</a>
        </li>
      ))}
    </ol>
  </nav>
);

export const ARTICLE_CONTENT_2 = {
  /* =================================================================
     4. Immunocal precio México 2026
     ================================================================= */
  "immunocal-precio-mexico-2026": (
    <>
      <p>Una de las preguntas que más me llegan por WhatsApp es: <em>"Sarai, ¿cuánto cuesta Immunocal en México y dónde lo compro confiable?"</em>. Es una pregunta válida, sobre todo porque Immunocal no se vende en farmacias ni tiendas físicas. En este artículo te explico todo lo que necesitas saber para tomar una decisión informada en 2026.</p>

      <TOC items={[
        { id: "presentaciones", label: "Las 3 presentaciones disponibles" },
        { id: "precios", label: "Precios públicos en México (2026)" },
        { id: "kit-inicio", label: "Kit de Inicio: hasta 45 % de descuento" },
        { id: "donde-comprar", label: "Dónde comprar (oficial y confiable)" },
        { id: "evitar", label: "Sitios y vendedores a evitar" },
        { id: "presupuesto", label: "Cómo planificar tu presupuesto mensual" },
        { id: "ayuda", label: "Cómo te ayudamos en Eliora Longevity" },
      ]} />

      <h2 id="presentaciones">Las 3 presentaciones disponibles</h2>
      <p>Immunocal viene en tres versiones, pensadas para distintos perfiles:</p>

      <h3>Immunocal Original</h3>
      <ul>
        <li><strong>Caja:</strong> 30 sobres de 10 g.</li>
        <li><strong>Para quién:</strong> adultos sanos que buscan soporte inmune y antioxidante general.</li>
        <li><strong>Dosis típica:</strong> 1 sobre al día en agua fría, en ayunas.</li>
      </ul>

      <h3>Immunocal Platinum</h3>
      <ul>
        <li><strong>Caja:</strong> 30 sobres de 25 g.</li>
        <li><strong>Para quién:</strong> personas 40+, mujeres en perimenopausia/menopausia, hombres en andropausia, deportistas masters, o quienes buscan apoyo óseo extra.</li>
        <li><strong>Extras vs. Original:</strong> citrato de potasio, citrato de magnesio, vitamina K1.</li>
        <li><strong>Dosis típica:</strong> 1-2 sobres al día.</li>
      </ul>
      <p>Profundiza en <Link to="/blog/immunocal-platinum-beneficios">Immunocal Platinum: por qué es la fórmula para mayores de 40</Link>.</p>

      <h3>Immunocal Sport</h3>
      <ul>
        <li><strong>Caja:</strong> 30 sobres con electrolitos.</li>
        <li><strong>Para quién:</strong> atletas, runners, ciclistas, crossfitters, futbolistas, cualquiera con entrenamiento intenso o de larga duración.</li>
        <li><strong>Extras:</strong> sodio, potasio, magnesio, creatina monohidratada, sabor cítrico suave.</li>
        <li><strong>Dosis típica:</strong> 1 sobre post-entrenamiento.</li>
      </ul>
      <p>Para detalles, mira <Link to="/blog/immunocal-sport-para-atletas">Immunocal Sport para atletas</Link>.</p>

      <h2 id="precios">Precios públicos en México (2026)</h2>
      <Callout>
        <strong>Aviso:</strong> los precios pueden ajustarse por inflación y ajustes oficiales de Immunotec. La info de abajo es orientativa para 2026. Para precio exacto al día de hoy, escríbeme y te lo confirmo.
      </Callout>

      <p>Rango aproximado precio público mexicano (caja de 30 sobres):</p>
      <ul>
        <li><strong>Immunocal Original:</strong> $2,800 – $3,200 MXN.</li>
        <li><strong>Immunocal Platinum:</strong> $3,400 – $3,800 MXN.</li>
        <li><strong>Immunocal Sport:</strong> $1,800 – $2,200 MXN.</li>
      </ul>

      <p>Sí, no es barato a primera vista. Por eso existe el Kit de Inicio, que es donde está la oportunidad real.</p>

      <h2 id="kit-inicio">Kit de Inicio: hasta 45 % de descuento</h2>
      <p>Immunotec opera con un modelo de Distribuidores Independientes (similar a Avon o Herbalife en estructura, pero con productos médicamente patentados). El <strong>Kit de Inicio</strong> te permite:</p>
      <ol>
        <li>Adquirir tu primera caja de Immunocal (o un combo) a <strong>precio de afiliado</strong>.</li>
        <li>Quedar registrada/o como Distribuidor Independiente — sin obligación de "vender" si no quieres.</li>
        <li>Comprar <strong>todas tus cajas futuras</strong> al mismo precio reducido.</li>
        <li>Acceder a promociones internas mensuales que solo ven los afiliados.</li>
      </ol>

      <Callout>
        <strong>Descuento real:</strong> el Kit de Inicio puede representar entre <strong>30 % y 45 % de descuento</strong> sobre el precio público, dependiendo del paquete elegido. Si vas a consumir Immunocal de forma sostenida, este es <strong>el único camino económicamente sensato</strong>.
      </Callout>

      <h2 id="donde-comprar">Dónde comprar (oficial y confiable)</h2>
      <p>Solo hay <strong>dos vías legítimas</strong> para comprar Immunocal en México:</p>
      <ol>
        <li><strong>A través de un Distribuidor Independiente Immunotec</strong> (como Eliora Longevity).</li>
        <li><strong>Desde la tienda oficial Immunotec</strong>, registrándote previamente con código de un Distribuidor.</li>
      </ol>
      <p>Si me contactas a través de <Link to="/">Eliora Longevity</Link>, te ayudo paso a paso a:</p>
      <ul>
        <li>Elegir la presentación correcta para tu caso.</li>
        <li>Registrarte en la tienda oficial con mi código.</li>
        <li>Asegurar el descuento Kit de Inicio.</li>
        <li>Recibir tu protocolo personalizado de 3 meses gratis (generado por IA).</li>
      </ul>

      <h2 id="evitar">Sitios y vendedores a evitar</h2>
      <p>Por seguridad y para no tirar tu dinero:</p>
      <ul>
        <li><strong>No compres en Amazon, MercadoLibre o Walmart Marketplace.</strong> Si aparece, es producto re-vendido sin garantía, posiblemente caducado o falsificado. Immunotec <strong>no autoriza</strong> esos canales.</li>
        <li><strong>No compres en farmacias.</strong> Immunocal no se vende ahí.</li>
        <li><strong>Verifica al Distribuidor.</strong> Pídele número de afiliado Immunotec y nombre completo. Cualquiera serio te lo dará sin dudar.</li>
        <li><strong>Desconfía de precios "sospechosamente bajos".</strong> Si alguien ofrece Immunocal Original a $1,200 MXN, casi seguro es falsificado o vencido.</li>
      </ul>

      <h2 id="presupuesto">Cómo planificar tu presupuesto mensual</h2>
      <p>Una caja dura 30 días si tomas 1 sobre al día. Algunos perfiles necesitan más:</p>
      <ul>
        <li><strong>Mantenimiento (adulto sano):</strong> 1 sobre/día = 1 caja/mes.</li>
        <li><strong>Estrés alto, sistema inmune débil, recuperación:</strong> 2 sobres/día = 2 cajas/mes.</li>
        <li><strong>Soporte clínico (con guía profesional):</strong> 3-4 sobres/día.</li>
      </ul>
      <p>Con el descuento de afiliado, el consumo mensual base ronda <strong>$1,500 a $2,000 MXN</strong> para Immunocal Original — el equivalente a un par de cenas en restaurante.</p>

      <Quote author="Sarai Núñez">
        Mi pregunta a quien duda: si gastas $200 al día en algo que no recuerdas al día siguiente, ¿no vale invertir $50 al día en tu salud celular?
      </Quote>

      <h2 id="ayuda">Cómo te ayudamos en Eliora Longevity</h2>
      <p>Sé que es mucha información. Por eso ofrezco:</p>
      <ul>
        <li><strong>Quiz Wellness gratuito:</strong> en 3 minutos genera tu protocolo personalizado. <Link to="/#quiz">Empezar quiz</Link>.</li>
        <li><strong>Asesoría 1 a 1 por WhatsApp:</strong> para resolver dudas concretas.</li>
        <li><strong>Acompañamiento durante los 3 primeros meses:</strong> seguimiento por email para que veas resultados reales.</li>
        <li><strong>Acceso al Kit de Inicio</strong> con el descuento completo.</li>
      </ul>

      <p>Para más contexto sobre productos y precios, lee también <Link to="/immunocal-precio">nuestra página de precios y dónde comprar</Link>.</p>
      <p>Tu salud no es un gasto. Es la inversión con más interés compuesto que puedes hacer.</p>
    </>
  ),

  /* =================================================================
     5. Biohacking para principiantes
     ================================================================= */
  "biohacking-para-principiantes": (
    <>
      <p>Cuando escuchas "biohacking", probablemente imaginas a un millonario de Silicon Valley conectado a 12 dispositivos, comiendo polvos raros y durmiendo en una cápsula con luces LED. La realidad es mucho más accesible: <strong>biohacking es tomar el control consciente de tu biología</strong> usando ciencia, hábitos y a veces tecnología. Y se puede empezar hoy, sin gastar miles.</p>

      <p>Te traigo <strong>10 hábitos comprobados</strong>, ordenados por impacto/costo. Aplica uno por semana y en 10 semanas tendrás otra vida.</p>

      <TOC items={[
        { id: "sol", label: "1. Sol matutino en los ojos" },
        { id: "agua", label: "2. Agua + electrolitos antes del café" },
        { id: "ayuno", label: "3. Ayuno intermitente 14/10" },
        { id: "frio", label: "4. Frío controlado" },
        { id: "caminar", label: "5. Caminar 10 minutos post-comida" },
        { id: "respiracion", label: "6. Respiración 4-7-8" },
        { id: "suplementos", label: "7. Suplementación dirigida" },
        { id: "sueno", label: "8. Higiene de sueño estricta" },
        { id: "ejercicio", label: "9. Z2 + fuerza, 5 días/semana" },
        { id: "medir", label: "10. Medir lo que importa" },
      ]} />

      <h2 id="sol">1. Sol matutino directo en los ojos</h2>
      <p><strong>10 minutos</strong> de exposición a luz solar matutina (sin lentes oscuros ni cristales) dentro de la primera hora de despertar. La razón: tu núcleo supraquiasmático —el "reloj maestro" del cerebro— necesita esa señal lumínica para fijar tu ritmo circadiano. Resultado: mejor sueño esa noche, mejor energía durante el día, mejor estado de ánimo.</p>
      <p><strong>Costo:</strong> $0. <strong>Impacto:</strong> enorme. Si vas a aplicar solo uno, que sea este.</p>

      <h2 id="agua">2. Agua + electrolitos antes del café</h2>
      <p>Pasaste 8 horas sin agua. Tus electrolitos están bajos. Antes del café:</p>
      <ul>
        <li>1 vaso grande de agua (300-500 ml).</li>
        <li>Una pizca de sal del Himalaya o sal de mar.</li>
        <li>Opcional: medio limón exprimido.</li>
      </ul>
      <p>Esto rehidrata, sube ligeramente la presión (importante para evitar el mareo matutino), y mejora la sensibilidad a la cafeína cuando sí te tomes el café.</p>

      <h2 id="ayuno">3. Ayuno intermitente 14/10</h2>
      <p>Olvida los regímenes extremos. Empieza con <strong>14 horas sin comer, 10 horas para comer</strong>. Por ejemplo: cierras cena 8 p. m., desayunas 10 a. m. Sin esfuerzo. Sin estrés.</p>
      <p>Beneficios:</p>
      <ul>
        <li>Mejora sensibilidad a la insulina.</li>
        <li>Activa autofagia (limpieza celular).</li>
        <li>Da descanso al sistema digestivo.</li>
        <li>Estabiliza energía y reduce antojos.</li>
      </ul>
      <Callout>
        <strong>Importante:</strong> el ayuno no es para todos en todo momento. Mujeres en edad fértil, embarazadas, personas con historial de trastornos alimentarios o con cortisol muy elevado deben ajustar o evitarlo. Consulta con un profesional si tienes dudas.
      </Callout>

      <h2 id="frio">4. Frío controlado al final de la ducha</h2>
      <p><strong>30 segundos de agua fría</strong> al final de tu ducha habitual. Después puedes subir a 1 minuto, 2 minutos, etc. No es masoquismo: la exposición al frío:</p>
      <ul>
        <li>Aumenta dopamina y norepinefrina (energía, foco, ánimo).</li>
        <li>Reduce inflamación crónica de bajo grado.</li>
        <li>Activa grasa parda metabólicamente activa.</li>
        <li>Entrena tu sistema nervioso a regular el estrés.</li>
      </ul>

      <h2 id="caminar">5. Caminar 10 minutos después de comer</h2>
      <p>Suena simple porque <em>es</em> simple. Una caminata ligera de 10-15 minutos después de la comida principal:</p>
      <ul>
        <li>Reduce el pico de glucosa posprandial <strong>hasta 30 %</strong>.</li>
        <li>Mejora digestión.</li>
        <li>Reduce somnolencia post-comida.</li>
      </ul>
      <p>Para vivir más años sanos, controlar la glucosa es uno de los <strong>top 3 hábitos</strong> con evidencia más robusta.</p>

      <h2 id="respiracion">6. Respiración 4-7-8 antes de dormir</h2>
      <p>Técnica del Dr. Andrew Weil. Cierra el día con:</p>
      <ol>
        <li>Inhalar por nariz durante <strong>4 segundos</strong>.</li>
        <li>Mantener el aire <strong>7 segundos</strong>.</li>
        <li>Exhalar por boca <strong>8 segundos</strong>.</li>
        <li>Repetir 4 a 8 ciclos.</li>
      </ol>
      <p>Activa el sistema parasimpático, baja cortisol, prepara el cuerpo para dormir profundo. Cero costo, beneficio instantáneo.</p>

      <h2 id="suplementos">7. Suplementación dirigida (no random)</h2>
      <p>El error #1 de los principiantes es comprar suplementos al azar. Empieza con la <strong>base medible</strong>:</p>
      <ul>
        <li><strong>Precursor de glutatión:</strong> <Link to="/immunocal">Immunocal</Link> u otra fuente de cisteína bioactiva. Es el #1 del biohacking real.</li>
        <li><strong>Omega-3 EPA/DHA:</strong> 1-2 g al día. Ver <Link to="/blog/omega-gen-v-5-en-1">Omega Gen V</Link>.</li>
        <li><strong>Vitamina D3 + K2:</strong> 2,000-5,000 UI con K2 MK7.</li>
        <li><strong>Magnesio glicinato o treonato:</strong> 200-400 mg antes de dormir.</li>
        <li><strong>Multi-vitamínico de calidad:</strong> base mineral.</li>
      </ul>

      <h2 id="sueno">8. Higiene de sueño estricta</h2>
      <ul>
        <li><strong>Habitación a 18-19 °C.</strong> Cuerpo necesita bajar 1°C para dormir profundo.</li>
        <li><strong>Oscuridad total.</strong> Cinta negra, blackout, antifaz.</li>
        <li><strong>Sin pantallas 60 min antes.</strong> La luz azul suprime melatonina.</li>
        <li><strong>Horario consistente.</strong> Mismo horario en fines de semana (más o menos 30 min).</li>
        <li><strong>Sin alcohol cerca del sueño.</strong> Fragmenta el sueño profundo, aunque "te ayude a dormir".</li>
      </ul>

      <h2 id="ejercicio">9. Z2 cardio + fuerza, 5 días/semana</h2>
      <p>Sin entrenarse para Iron Man:</p>
      <ul>
        <li><strong>3 sesiones cardio Z2:</strong> 30-45 min a ritmo en que puedas hablar (no jadear). Camina, trota, bici, nada.</li>
        <li><strong>2 sesiones de fuerza:</strong> 30-45 min, movimientos compuestos (sentadilla, peso muerto, empuje, jalón). 3 series por ejercicio.</li>
      </ul>
      <p>Este protocolo es el más respaldado para longevidad: aumenta VO2 max, preserva masa muscular y mejora sensibilidad a la insulina.</p>

      <h2 id="medir">10. Mide lo que importa</h2>
      <p>"Lo que se mide, mejora." No necesitas un Oura Ring carísimo para empezar:</p>
      <ul>
        <li>Pasos diarios (cualquier celular).</li>
        <li>Horas de sueño.</li>
        <li>Peso, semanal (no diario).</li>
        <li>Energía subjetiva 1-10 al despertar.</li>
        <li>Si puedes invertir: HRV (variabilidad cardíaca), Oura/Whoop/Polar.</li>
      </ul>

      <Callout>
        <strong>Plan de implementación:</strong> Semana 1 → solo Sol matutino. Semana 2 → suma agua + electrolitos. Semana 3 → suma caminata post-comida. Etc. <strong>Un hábito a la vez.</strong> Sostenido {">"} perfecto.
      </Callout>

      <p>El biohacking no es perfección, es <strong>iteración consciente</strong>. Si quieres un plan completo y personalizado, <Link to="/#quiz">haz nuestro quiz wellness gratuito</Link> y recibe tu protocolo de 3 meses generado con IA.</p>
    </>
  ),

  /* =================================================================
     6. Cómo estar preparado cuando la enfermedad llega
     ================================================================= */
  "como-estar-preparado-cuando-la-enfermedad-llega": (
    <>
      <p>Hay una frase que me gusta repetir cuando hablo con clientes nuevos: <em>"Las enfermedades no aparecen de un día para otro"</em>. Se incuban —en silencio, durante años— mucho antes de que aparezca el primer síntoma visible. La medicina tradicional, por estructura, atiende cuando ya hay diagnóstico. La medicina funcional, en cambio, mira <strong>el terreno</strong>: el cuerpo en el que la enfermedad germina.</p>
      <p>Si entiendes esto, puedes tomar decisiones hoy que cambian radicalmente cómo enfrentarás los retos de salud del futuro. Esa es la mirada de la medicina funcional: <strong>preparación, no reacción</strong>.</p>

      <TOC items={[
        { id: "terreno", label: "El concepto de 'terreno biológico'" },
        { id: "reservas", label: "Construir reservas antes de necesitarlas" },
        { id: "carga", label: "Reducir la carga total del cuerpo" },
        { id: "señales", label: "Conocer tus señales tempranas" },
        { id: "protocolo", label: "Protocolo de preparación realista" },
        { id: "errores", label: "Errores comunes que dejan el cuerpo vulnerable" },
        { id: "mentalidad", label: "Mentalidad: confianza tranquila" },
      ]} />

      <h2 id="terreno">El concepto de "terreno biológico"</h2>
      <p>Louis Pasteur, padre de la microbiología, lo dijo en su lecho de muerte: <em>"El microbio no es nada, el terreno lo es todo"</em>. Su rival, Claude Bernard, lo defendía desde décadas antes. Hoy, la ciencia les da la razón con un giro: <strong>tanto el microbio como el terreno importan, pero el terreno es la palanca que tú controlas</strong>.</p>
      <p>Dos personas expuestas al mismo virus, al mismo carcinógeno, al mismo estrés: una se enferma gravemente, la otra apenas lo nota. La diferencia es el terreno: niveles antioxidantes, microbiota, inflamación basal, función mitocondrial, salud hormonal.</p>

      <h2 id="reservas">Construir reservas antes de necesitarlas</h2>
      <p>Piensa en tu cuerpo como una cuenta bancaria biológica. Cada día depositas o retiras de varias "cuentas":</p>

      <h3>Cuenta antioxidante</h3>
      <p>Depósitos: glutatión adecuado (vía <Link to="/immunocal">Immunocal</Link>), alimentos coloridos, sueño reparador. Retiros: alcohol, tabaco, contaminación, estrés.</p>

      <h3>Cuenta mineral</h3>
      <p>Depósitos: vegetales de hoja verde, frutos secos, agua mineral, mariscos. Retiros: refrescos (fósforo lava magnesio y calcio), sudor sin reposición, café excesivo.</p>

      <h3>Cuenta microbiota</h3>
      <p>Depósitos: fibra fermentable, alimentos fermentados, prebióticos, diversidad alimentaria. Retiros: antibióticos sin prebióticos posteriores, ultraprocesados, estrés crónico, alcohol.</p>

      <h3>Cuenta mitocondrial</h3>
      <p>Depósitos: ejercicio (especialmente Z2), ayuno suave, frío controlado, CoQ10, omega-3. Retiros: sedentarismo, exceso de azúcar, infecciones recurrentes.</p>

      <Callout>
        <strong>El principio:</strong> cuando una infección, lesión o estrés mayor llega, tu cuerpo "tira" de esas reservas. Si están vacías, la respuesta es lenta, ineficiente y deja secuelas. Si están llenas, sales adelante con relativa facilidad.
      </Callout>

      <h2 id="carga">Reducir la carga total del cuerpo</h2>
      <p>Hay un concepto en medicina funcional llamado <strong>"carga alostática"</strong>: la suma total de estresores que tu organismo está procesando en este momento. Incluye:</p>
      <ul>
        <li>Toxinas ambientales (PM2.5, microplásticos, pesticidas).</li>
        <li>Toxinas dietarias (aceites oxidados, aditivos, exceso de azúcar).</li>
        <li>Sueño insuficiente o fragmentado.</li>
        <li>Estrés psicológico y emocional.</li>
        <li>Infecciones crónicas de bajo grado (encías, intestinal).</li>
        <li>Alergenos e intolerancias no detectadas.</li>
        <li>Sedentarismo o, por el contrario, ejercicio extremo.</li>
        <li>Ruido, falta de naturaleza, exceso de pantallas.</li>
      </ul>
      <p>Cada uno por separado parece poca cosa. Sumados son un <strong>peso enorme</strong> que consume tu capacidad de respuesta.</p>
      <p>La estrategia: identifica los 3 estresores más grandes en <em>tu</em> vida y trabaja en ellos. No se trata de eliminarlos todos —imposible— sino de <strong>aliviar el sistema</strong>.</p>

      <h2 id="señales">Conocer tus señales tempranas</h2>
      <p>Tu cuerpo te avisa antes de gritar. Estas son señales que la medicina funcional toma <strong>en serio</strong> aunque la tradicional las normalice:</p>
      <ul>
        <li>Fatiga matutina constante.</li>
        <li>Despertares nocturnos a las 3 a. m. (señal hepática).</li>
        <li>Hinchazón abdominal recurrente.</li>
        <li>Infecciones repetidas (cistitis, vaginosis, sinusitis).</li>
        <li>Alergias nuevas en la edad adulta.</li>
        <li>Pérdida de memoria a corto plazo.</li>
        <li>Cambios en el patrón intestinal.</li>
        <li>Reaparición de eczema, acné o caspa adulta.</li>
        <li>Sensibilidad creciente a olores, ruido o luces.</li>
        <li>Dolor articular sin causa traumática.</li>
      </ul>
      <p>Si tienes 3 o más de estas señales de forma sostenida, tu cuerpo está pidiendo atención. <em>No</em> son "envejecimiento normal".</p>

      <h2 id="protocolo">Protocolo de preparación realista</h2>
      <p>Esto es lo que yo recomiendo, ordenado por impacto:</p>

      <ol>
        <li><strong>Eleva glutatión de forma consistente.</strong> <Link to="/immunocal">Immunocal</Link> diario, mínimo 90 días. No esperes a estar enferma para empezar.</li>
        <li><strong>Vitamina D3 entre 50-80 ng/ml.</strong> Mide con análisis. Suplementa si estás bajo (suele requerirse 2,000-5,000 UI/día + K2 MK7).</li>
        <li><strong>Omega-3 EPA/DHA &gt; 1 g/día.</strong> Pescado azul 2-3 veces/semana o suplementación de calidad.</li>
        <li><strong>30 g de fibra al día.</strong> Verduras, legumbres, semillas, fruta entera (no jugo).</li>
        <li><strong>Sueño 7-9 h en horario consistente.</strong> Innegociable.</li>
        <li><strong>Movimiento diario + 1 día completo de descanso.</strong></li>
        <li><strong>Hidratación adecuada con minerales.</strong> 30 ml por kg de peso + pizca de sal.</li>
        <li><strong>Comunidad y vínculo.</strong> Las personas con conexiones sociales fuertes viven más y con menos enfermedad. Es ciencia, no opinión.</li>
        <li><strong>Manejo de estrés diario.</strong> Oración, meditación, naturaleza, journaling. Lo que sea, pero <em>diario</em>.</li>
      </ol>

      <h2 id="errores">Errores comunes que dejan el cuerpo vulnerable</h2>
      <ul>
        <li>Pensar que "joven" = "invulnerable". El terreno se construye antes de los 40, no después.</li>
        <li>Tomar suplementos solo cuando ya estás enfermo. Es como ahorrar para la emergencia el día que pasa.</li>
        <li>Confiar solo en análisis de rutina. La medicina tradicional detecta cuando ya hay desequilibrio claro; la funcional mira tendencias.</li>
        <li>Ignorar señales menores. Son <em>información</em>, no molestias.</li>
        <li>Cambiar todo de golpe (y abandonar todo a las 2 semanas). Un hábito a la vez, sostenido.</li>
      </ul>

      <h2 id="mentalidad">Mentalidad: confianza tranquila</h2>
      <p>El objetivo de prepararte <strong>no es vivir con miedo</strong> a enfermarte. Eso es estrés crónico disfrazado de "cuidado". El objetivo es vivir con <em>confianza tranquila</em>: la certeza de que has hecho tu parte —construido reservas, reducido carga, mantenido buenos hábitos— y que cuando un reto llegue, tu cuerpo tiene los recursos para responder bien.</p>
      <p>Esa paz interior es, paradójicamente, uno de los factores más protectores que existen para la salud.</p>

      <Quote author="Sarai Núñez">
        Cuida tu terreno cuando estés sana. Tu yo del futuro te lo agradecerá en silencio cada día que el cuerpo responda como necesitas.
      </Quote>

      <p>Si quieres un plan completo y personalizado, <Link to="/#quiz">haz nuestro quiz wellness gratis</Link>. Y para entender por qué empezamos siempre por el glutatión, te recomiendo <Link to="/blog/que-es-el-glutation-antioxidante-maestro">esta guía</Link>.</p>
    </>
  ),
};

export default ARTICLE_CONTENT_2;
